import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as userTermSelectors from "./userTermSelectors";
import * as userTermActions from "./userTermActions";
import { PageHeader } from "../common/PageHeader";
import UserTermListRow from "./UserTermListRow";
import Spinner from "../common/Spinner";
import { routes } from "../../appRoutingHelpers";

interface Props {}

const UserTermList: React.FC<Props> = (props) => {
  // const t = (props as any).t;

  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const userTerms = useSelector((state: RootState) =>
    userTermSelectors.listUserTerms(state, organizationKeyName)
  );

  const isLoadingUserTermList = useSelector((state: RootState) =>
    userTermSelectors.isLoadingUserTermList(state, organizationKeyName)
  );

  const dispatch = useDispatch();
  // const params = useParams<{id: string}>();

  React.useEffect(() => {
    dispatch(userTermActions.getUserTermListAction(organizationKeyName));
  }, [dispatch, organizationKeyName]);

  return (
    <div className="container">
      <PageHeader
        title="User term list"
        breadcrumbs={[
          { title: "User Term list" },
          { title: "Overview", isActive: true },
        ]}
      />

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">User Term List</h3>
              <div className="card-options">
                <Link
                  className="btn btn-primary btn-sm"
                  to={routes.userTermAdd(organizationKeyName)}
                >
                  New user term
                </Link>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover table-outline table-vcenter card-table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Created at</th>
                    <th>Key Name</th>
                    <th>Description</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {userTerms?.map((userTerm) => (
                    <UserTermListRow
                      organization={organizationKeyName}
                      key={userTerm.id}
                      userTerm={userTerm}
                    />
                  ))}
                </tbody>
              </table>
            </div>{" "}
            {isLoadingUserTermList && (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(UserTermList);
